import { UmsActionTypes } from "./actions";

export const initialState = {
  preferences: {
    prefsConfigSettings: {},
    prefsInvoiceSettings: {},
    advancedCustomerConfiguration: {},
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UmsActionTypes.FETCH_PREFERENCES.SUCCESS: {
      return {
        ...state,
        preferences: action.payload,
      };
    }
    default:
      return state;
  }
};
